import {DrawingDataItem, DrawingDataItemDrawResult, DrawingDataItemPoint} from "../drawingOnImageDrawingElement.model";

export class DrawingDataItemShape extends DrawingDataItem {
    constructor() {
        super();
        this.typeValue = 'shape';
        this.properties = {
            points: [],
        }
    }

    public getPointsToMove(): DrawingDataItemPoint[] {
        if (!this.properties?.points) {
            return [];
        }
        return this.properties.points.map((point: any) => DrawingDataItemPoint.fromVisiblePoint(point));
    }

    onMouseUp(canvasRelativeX: number, canvasRelativeY: number): DrawingDataItemDrawResult {
        return {
            changed: false,
            stillDrawing: false
        }
    }

    onMouseDown(canvasRelativeX: number, canvasRelativeY: number): DrawingDataItemDrawResult {
        return {
            changed: false,
            stillDrawing: true
        }
    }

    onMouseMove(canvasRelativeX: number, canvasRelativeY: number): DrawingDataItemDrawResult {
        this.properties.points.push({
            x: canvasRelativeX,
            y: canvasRelativeY
        });
        return {
            changed: true,
            stillDrawing: true
        }
    }

    draw(ctx: CanvasRenderingContext2D) {
        const points: any[] = this.properties.points;
        // console.log('points', points);
        if (points.length > 0) {
            ctx.beginPath();
            this.applyCommonToCanvas(ctx);
            ctx.moveTo(points[0].x, points[0].y);
            for (let i = 1; i < points.length; i++) {
                ctx.lineTo(points[i].x, points[i].y);
            }
            ctx.stroke();
        }
    }
}